export default __webpack_public_path__ + "static/media/sofa-1-seat-3-back.845c8282.webp";